export const sample = {
  heading: "Something in Norsk",
  warning: "Warning",
};
